export { default } from './Avatar';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Avatar/index.js
// module id = 399
// module chunks = 2